// src/App.tsx
import React from 'react';
import { BrowserRouter as Router, Switch, Route, withRouter, RouteComponentProps } from 'react-router-dom';
import { Provider, inject, observer } from 'mobx-react';
import DownloadApp from '@components/downloadApp';
import routes from './routes';
import initializeStore from './stores';
import './App.css';
import '@common/style/common.scss'
import Header from '@components/header';
import { px2rem } from '@utils/px2rem';
import { getUrlParams } from '@utils/getUrlParams';
import { listenScrollDirection, getScrollPosition } from '@utils/scrollUtils';
import { getCookie } from '@utils/cookie';

class RouteTrackerBase extends React.Component<RouteComponentProps> {
  unlisten?: () => void;
  // 记录上一次的路径，用于区分“换页面”和“同页面改查询参数”。
  previousPathname = window.location.pathname;

  componentDidMount() {
    // console.log('进入club');
    // 浏览器自带的滚动恢复会和路由切换抢位置，改为手动控制。
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    // 首次进入由 hm.js 自动记录，这里只处理单页路由切换。
    this.unlisten = this.props.history.listen((location, action) => {
      const pageUrl = `${location.pathname}${location.search}${location.hash}`;
      if (window._hmt && typeof window._hmt.push === 'function') {
        window._hmt.push(['_trackPageview', pageUrl]);
      }

      const pathChanged = location.pathname !== this.previousPathname;
      this.previousPathname = location.pathname;

      // POP 是浏览器前进后退，保留原位置；锚点跳转交给页面自己处理。
      if (action === 'POP' || location.hash) return;
      // 仅在真正进入新页面（换路径）或主动 push 时置顶，
      // 避免同页面用 replace 同步 tab、筛选等查询参数时把列表弹回顶部。
      if (pathChanged || action === 'PUSH') {
        window.scrollTo(0, 0);
      }
    });
  }

  componentWillUnmount() {
    if (this.unlisten) {
      this.unlisten();
    }
  }

  render() {
    return null;
  }
}

const RouteTracker = withRouter(RouteTrackerBase);

interface AppState {
  // showDownloadApp: boolean
  // windowWidth: number;
  // scrollY: number;
  scrollDirection: 'up' | 'down' | null; // 新增：滚动方向
  // lastScrollY: number; // 新增：上一次滚动位置
}
// 添加 @inject 装饰器
// @inject('site')
@observer
class App extends React.Component {
  // 作为类属性直接定义
  scrollCleanup = null;
  store = initializeStore();
  state: AppState = {
    scrollDirection: null, // 新增：滚动方向
  };
  componentDidMount() {
    // access_token 可能无法由前端直接读取，只要 user_code 存在就恢复登录态并拉取用户信息。
    this.store?.user?.hydrateLoginState?.();

    if (this.store && this.store.site && typeof this.store.site.fetchEmoji === 'function') {
      this.store.site.fetchEmoji()
    }
    // 1. 获取所有参数
    const allParams = getUrlParams();
    console.log(allParams, '参数');

    const jumpUrl = window.localStorage.getItem('__jump_url');
    // 子路由的 componentDidMount 会先于 App 执行。未登录页面此时刚写入
    // __jump_url 并准备前往 OAuth，不能在这里立刻把地址改回受保护页面。
    // 只有 OAuth 成功写入 user_code 后才消费回跳地址。
    if (jumpUrl && getCookie('user_code')) {
      window.localStorage.removeItem('__jump_url');

      try {
        const targetUrl = new URL(jumpUrl, window.location.origin);
        // OAuth 已经直接回到目标页时只清理记录，避免再次刷新当前页面。
        if (targetUrl.href !== window.location.href) {
          window.location.replace(targetUrl.href);
          return;
        }
      } catch (error) {
        console.warn('忽略无效的登录回跳地址：', jumpUrl);
      }
    }

    // 使用滚动监听方法scrollData.direction, scrollData.scrollY
    this.scrollCleanup = listenScrollDirection((scrollData) => {
      this.setState({ 
        scrollDirection: scrollData.direction,
      });
      this.handleScrollDirection(scrollData.direction);
    });
  }

  componentWillUnmount() {
    // 确保清理监听器
    if (this.scrollCleanup) {
      this.scrollCleanup();
    }

  }
  // 检测滚动方法
  handleScrollDirection = (direction) => {
    // 处理滚动方向变化的逻辑
    // console.log('检测到滚动:', direction);
  };

  // 关闭h5顶部的下载app入口
  closeAppDownloadEnterClick = () => {
    if (this.store?.site) {
      this.store.site.setAppDownloadShowStatus(false);
      console.log('下载入口已关闭');
    } else {
      console.error('site store 不可用');
    }
}

  render() {
    let { scrollDirection } = this.state;
    const platform = this.store && this.store.app && this.store.app.platform ? this.store.app.platform : 'h5';
    const showHeader = this.store && this.store.site ? this.store.site.showHeader : true;
    const showDownloadApp = this.store && this.store.site ? this.store.site.appDownloadShowStatus: true;
    // console.log('下载入口显示状态', showDownloadApp);
    return (
      <Provider {...this.store}>
        <Router>
          <RouteTracker />
          <div className={`App ${platform}`}> {/* 动态添加 pc/h5 class */}
          {(showDownloadApp && platform == 'h5') && <DownloadApp closeAppDownloadEnter={this.closeAppDownloadEnterClick}></DownloadApp>}
            {/* {(showHeader && getUrlParams().source != 'app' && (scrollDirection == 'up' || scrollDirection == null)) &&  */}
              <Header showDownloadApp={showDownloadApp} handleSetState={(data, rep) => this.setState({ ...data })} isShowHeader={(showHeader && getUrlParams().source != 'app' && (scrollDirection == 'up' || scrollDirection == null)) ? true : false}></Header>
             {/* } */}
            <div className={`wrap${platform === 'pc' ? ' pc-wrap' : ' h5-wrap'}`} style={{ paddingTop: getUrlParams().source == 'app' ? '0' : !showHeader ? 0 : platform === 'pc' ? 0 : !showDownloadApp ? px2rem(88) : px2rem(176) }}>
              <Switch>
                {routes.map((route, index) => (
                  <Route
                    key={index}
                    path={route.path}
                    component={route.component}
                    exact={route.path === '/'}
                  />
                ))}
              </Switch>
            </div>
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
